export enum ThreeplsProviderType {
  DeliverySolution = "DeliverySolution",
  Uber = "Uber",
  TrainIL = "TrainIL",
  Contractor = "Contractor"
}
